// extracted by mini-css-extract-plugin
module.exports = {"root":"Client_root__RTlij","image":"Client_image___7Ia_","link":"Client_link__UQLMl"};